import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
        },
        searchBar: {
            width: '100%',
        },
        details: {
            color: theme.palette.grey[600],
        },
        title: {
            marginBottom: theme.spacing(1),
        },
        action: {
            color: theme.palette.info.main,
            cursor: 'pointer',
        },
    };
});
